<template>
  <div>



      <admin-form-item :label="page.name">
        <div class="flex space-between lp-table-row" v-for="(panel, idx) in page.panel">
          <div>{{ panel.name }}</div>
          <toggle-button @change="e => panel.enable = e.value"
                         :value="panel.enable"
                         :sync="true"
                         class="changed-font"
                         :width="70"
                         :height="24"
                         :labels="{'checked':'활성화', 'unchecked':'비활성화'}"></toggle-button>
        </div>
      </admin-form-item>


  </div>
</template>
<script>
  import ToggleButton from "vue-js-toggle-button/src/Button";
  import LpCheckBool from "../common/LpCheckBool";

  export default {
    // page는 변경할 페이지명
    props: ['page'],
    components: {
      LpCheckBool,
      ToggleButton},
    data() {
      return {

      }
    },
    created() {

    },
    methods: {

    }
  }
</script>
<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .lp-table-row
    padding 6px 0
    border-bottom 1px solid rgb(152, 152, 152)

</style>
